import { ArrowDownWideNarrow, ChevronDown } from "lucide-react";
import { ToolbarButton } from "./toolbar-button";
import { YearTabs } from "./year-tabs";

interface ReportListToolbarProps {
  years: number[];
  activeYear: number;
  onYearChange: (year: number) => void;
  /** 방금 업로드된 보고서가 들어간 연도 */
  newYears?: Set<number>;
  /** 종류 필터 컨트롤 (container가 드롭다운 주입). 없으면 기본 버튼. */
  typeControl?: React.ReactNode;
  /** 정렬 컨트롤 (container가 주입). 없으면 기본 버튼. */
  sortControl?: React.ReactNode;
}

// ============================================
// ReportListToolbar
// "보고서 목록" 라벨 + 연도 탭 · 종류 필터 · 정렬. 레이아웃만 담당(표현).
// ============================================

export const ReportListToolbar = ({
  years,
  activeYear,
  onYearChange,
  newYears,
  typeControl,
  sortControl,
}: ReportListToolbarProps) => (
  <div className="flex w-full flex-col gap-4">
    <h2 className="label-1-normal-semibold text-label-normal">보고서 목록</h2>

    <div className="flex w-full items-center justify-between">
      <div className="flex items-center gap-2">
        <YearTabs
          years={years}
          activeYear={activeYear}
          onChange={onYearChange}
          newYears={newYears}
        />
        <div className="h-[30px] w-px bg-neutral-200" />
        {typeControl ?? (
          <ToolbarButton
            className="w-[140px]"
            spread
            rightIcon={<ChevronDown className="size-4" />}
          >
            종류
          </ToolbarButton>
        )}
      </div>

      {sortControl ?? (
        <ToolbarButton
          className="shadow-sm"
          rightIcon={<ArrowDownWideNarrow className="size-4" />}
        >
          정렬
        </ToolbarButton>
      )}
    </div>
  </div>
);
